// Collection of UI warnings
import i18n from 'i18next';

if (!Mobi2Go.UI.warnings) Mobi2Go.UI.warnings = {};

Mobi2Go.UI.warnings.warnForUnavailableAndRestrictedProducts = function(
    location,
    callback
) {
    const basket_products_to_be_removed = Mobi2Go.Order.getUnavailableAndRestrictedProductsForLocation(
        location
    );

    if (!basket_products_to_be_removed.length) {
        callback(true);
        return;
    }

    let title = i18n.t('ui-warnings:items_unavailable_title');
    let body = i18n.t('ui-warnings:items_unavailable_body', {
        location_name: location.name,
    });

    if (basket_products_to_be_removed.length === 1) {
        const { menu_product } = basket_products_to_be_removed[0];

        title = i18n.t('ui-warnings:one_item_unavailable_title', {
            product_name: menu_product.name,
        });
        body = i18n.t('ui-warnings:one_item_unavailable_body', {
            product_name: menu_product.name,
            location_name: location.name,
        });

        if (
            !location.isProductRestricted(
                menu_product,
                Mobi2Go.Order.getExpectedAt()
            )
        ) {
            // If product is to be removed but not restricted it means some of its modifiers could be unavailable.
            const restricted_modifiers = Mobi2Go.Order.getRestrictedModifiersForLocationAndProduct(
                location,
                basket_products_to_be_removed[0]
            );

            if (restricted_modifiers.length === 1) {
                const { menu_modifier } = restricted_modifiers[0];
                body = i18n.t('ui-warnings:one_modifier_unavailable_body', {
                    product_name: menu_product.name,
                    modifier_name: menu_modifier.name,
                    location_name: location.name,
                });
            } else if (restricted_modifiers.length > 1) {
                body = i18n.t('ui-warnings:modifiers_unavailable_body', {
                    product_name: menu_product.name,
                    location_name: location.name,
                });
            }
        }
    } else if (basket_products_to_be_removed.length === 2) {
        body = i18n.t('ui-warnings:two_items_unavailable_body', {
            product_name_1: basket_products_to_be_removed[0].menu_product.name,
            product_name_2: basket_products_to_be_removed[1].menu_product.name,
            location_name: location.name,
        });
    }

    Mobi2Go.UI.centeredAlert({
        id: 'items-unavailable',
        title,
        body,
        primary_button: i18n.t('ui-warnings:items_unavailable_primary_button'),
        onPrimaryButtonClick() {
            callback(true);
        },
        secondary_button: i18n.t(
            'ui-warnings:items_unavailable_secondary_button'
        ),
        onSecondaryButtonClick() {
            callback(false);
        },
    });
};
